var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"blog-footer"},[_c('div',{staticClass:"blog-footer__tag-list"},[_vm._l((_vm.tagList),function(tag){return [_c('blogpost-tag',{key:tag.id,attrs:{"id":tag.id}},[_vm._v(_vm._s(tag.description))])]})],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }